/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { customerClubDevicesChangeCustomerClubDeviceStatus } from '../fn/customer-club-devices/customer-club-devices-change-customer-club-device-status';
import { CustomerClubDevicesChangeCustomerClubDeviceStatus$Params } from '../fn/customer-club-devices/customer-club-devices-change-customer-club-device-status';
import { customerClubDevicesCreateGet } from '../fn/customer-club-devices/customer-club-devices-create-get';
import { CustomerClubDevicesCreateGet$Params } from '../fn/customer-club-devices/customer-club-devices-create-get';
import { customerClubDevicesCreatePost } from '../fn/customer-club-devices/customer-club-devices-create-post';
import { CustomerClubDevicesCreatePost$Params } from '../fn/customer-club-devices/customer-club-devices-create-post';
import { customerClubDevicesDeleteDelete } from '../fn/customer-club-devices/customer-club-devices-delete-delete';
import { CustomerClubDevicesDeleteDelete$Params } from '../fn/customer-club-devices/customer-club-devices-delete-delete';
import { customerClubDevicesDeleteGet } from '../fn/customer-club-devices/customer-club-devices-delete-get';
import { CustomerClubDevicesDeleteGet$Params } from '../fn/customer-club-devices/customer-club-devices-delete-get';
import { customerClubDevicesGetCustomerClubDeviceAuditWithPagination } from '../fn/customer-club-devices/customer-club-devices-get-customer-club-device-audit-with-pagination';
import { CustomerClubDevicesGetCustomerClubDeviceAuditWithPagination$Params } from '../fn/customer-club-devices/customer-club-devices-get-customer-club-device-audit-with-pagination';
import { customerClubDevicesGetCustomerClubDeviceWithPagination } from '../fn/customer-club-devices/customer-club-devices-get-customer-club-device-with-pagination';
import { CustomerClubDevicesGetCustomerClubDeviceWithPagination$Params } from '../fn/customer-club-devices/customer-club-devices-get-customer-club-device-with-pagination';
import { customerClubDevicesUpdateGet } from '../fn/customer-club-devices/customer-club-devices-update-get';
import { CustomerClubDevicesUpdateGet$Params } from '../fn/customer-club-devices/customer-club-devices-update-get';
import { customerClubDevicesUpdatePut } from '../fn/customer-club-devices/customer-club-devices-update-put';
import { CustomerClubDevicesUpdatePut$Params } from '../fn/customer-club-devices/customer-club-devices-update-put';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetCustomerClubDeviceByIdDto } from '../models/custom-result-of-get-customer-club-device-by-id-dto';
import { CustomResultOfPaginatedListOfGetCustomerClubDeviceWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-customer-club-device-with-pagination-dto';

@Injectable({ providedIn: 'root' })
export class CustomerClubDevicesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `customerClubDevicesCreateGet()` */
  static readonly CustomerClubDevicesCreateGetPath = '/CustomerClubDevices/Create';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerClubDevicesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerClubDevicesCreateGet$Response(params?: CustomerClubDevicesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return customerClubDevicesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerClubDevicesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerClubDevicesCreateGet(params?: CustomerClubDevicesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.customerClubDevicesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `customerClubDevicesCreatePost()` */
  static readonly CustomerClubDevicesCreatePostPath = '/CustomerClubDevices/Create';

  /**
   * ایجاد تنظیمات.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerClubDevicesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesCreatePost$Response(params: CustomerClubDevicesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return customerClubDevicesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد تنظیمات.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerClubDevicesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesCreatePost(params: CustomerClubDevicesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.customerClubDevicesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `customerClubDevicesUpdateGet()` */
  static readonly CustomerClubDevicesUpdateGetPath = '/CustomerClubDevices/Update';

  /**
   * دریافت تنظیمات بر اساس شناسه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerClubDevicesUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerClubDevicesUpdateGet$Response(params?: CustomerClubDevicesUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetCustomerClubDeviceByIdDto>> {
    return customerClubDevicesUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تنظیمات بر اساس شناسه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerClubDevicesUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerClubDevicesUpdateGet(params?: CustomerClubDevicesUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetCustomerClubDeviceByIdDto> {
    return this.customerClubDevicesUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetCustomerClubDeviceByIdDto>): CustomResultOfGetCustomerClubDeviceByIdDto => r.body)
    );
  }

  /** Path part for operation `customerClubDevicesUpdatePut()` */
  static readonly CustomerClubDevicesUpdatePutPath = '/CustomerClubDevices/Update';

  /**
   * ویرایش تنظیمات.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerClubDevicesUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesUpdatePut$Response(params: CustomerClubDevicesUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return customerClubDevicesUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش تنظیمات.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerClubDevicesUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesUpdatePut(params: CustomerClubDevicesUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.customerClubDevicesUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `customerClubDevicesDeleteGet()` */
  static readonly CustomerClubDevicesDeleteGetPath = '/CustomerClubDevices/Delete';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerClubDevicesDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerClubDevicesDeleteGet$Response(params?: CustomerClubDevicesDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return customerClubDevicesDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerClubDevicesDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerClubDevicesDeleteGet(params?: CustomerClubDevicesDeleteGet$Params, context?: HttpContext): Observable<Blob> {
    return this.customerClubDevicesDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `customerClubDevicesDeleteDelete()` */
  static readonly CustomerClubDevicesDeleteDeletePath = '/CustomerClubDevices/Delete';

  /**
   * حذف تنظیمات.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerClubDevicesDeleteDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesDeleteDelete$Response(params: CustomerClubDevicesDeleteDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return customerClubDevicesDeleteDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف تنظیمات.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerClubDevicesDeleteDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesDeleteDelete(params: CustomerClubDevicesDeleteDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.customerClubDevicesDeleteDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `customerClubDevicesGetCustomerClubDeviceWithPagination()` */
  static readonly CustomerClubDevicesGetCustomerClubDeviceWithPaginationPath = '/CustomerClubDevices/GetCustomerClubDeviceWithPagination';

  /**
   * دریافت تنظیمات با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerClubDevicesGetCustomerClubDeviceWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesGetCustomerClubDeviceWithPagination$Response(params: CustomerClubDevicesGetCustomerClubDeviceWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetCustomerClubDeviceWithPaginationDto>> {
    return customerClubDevicesGetCustomerClubDeviceWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تنظیمات با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerClubDevicesGetCustomerClubDeviceWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesGetCustomerClubDeviceWithPagination(params: CustomerClubDevicesGetCustomerClubDeviceWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetCustomerClubDeviceWithPaginationDto> {
    return this.customerClubDevicesGetCustomerClubDeviceWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetCustomerClubDeviceWithPaginationDto>): CustomResultOfPaginatedListOfGetCustomerClubDeviceWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `customerClubDevicesGetCustomerClubDeviceAuditWithPagination()` */
  static readonly CustomerClubDevicesGetCustomerClubDeviceAuditWithPaginationPath = '/CustomerClubDevices/GetCustomerClubDeviceAuditWithPagination';

  /**
   * دریافت لاگ.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerClubDevicesGetCustomerClubDeviceAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesGetCustomerClubDeviceAuditWithPagination$Response(params: CustomerClubDevicesGetCustomerClubDeviceAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return customerClubDevicesGetCustomerClubDeviceAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لاگ.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerClubDevicesGetCustomerClubDeviceAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesGetCustomerClubDeviceAuditWithPagination(params: CustomerClubDevicesGetCustomerClubDeviceAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.customerClubDevicesGetCustomerClubDeviceAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `customerClubDevicesChangeCustomerClubDeviceStatus()` */
  static readonly CustomerClubDevicesChangeCustomerClubDeviceStatusPath = '/CustomerClubDevices/ChangeCustomerClubDeviceStatus';

  /**
   * ویرایش وضعیت دستگاه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerClubDevicesChangeCustomerClubDeviceStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesChangeCustomerClubDeviceStatus$Response(params: CustomerClubDevicesChangeCustomerClubDeviceStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return customerClubDevicesChangeCustomerClubDeviceStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش وضعیت دستگاه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerClubDevicesChangeCustomerClubDeviceStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerClubDevicesChangeCustomerClubDeviceStatus(params: CustomerClubDevicesChangeCustomerClubDeviceStatus$Params, context?: HttpContext): Observable<CustomResult> {
    return this.customerClubDevicesChangeCustomerClubDeviceStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
